import getTextForCreditCard from './getTextForCreditCard';
import getTextForDebitCard from './getTextForDebitCard';
import getTextForDcardDelivery from './getTextForDcardDelivery';

export default function determinePriority(
    creditCardLocalStorageData,
    debitCardDeliveryLocalStorageData,
    debitCardLocalStorageData,
    noStretchingArray,
    creditCardRetentionData,
    debitCardDeliveryRetentionData,
    debitCardRetentionData
) {
    const dataDeterminePriority = {
        currentCard: '',
        variableForText: '',
        text: '',
    };

    if (creditCardLocalStorageData && !noStretchingArray?.includes('ccard')) {
        dataDeterminePriority.currentCard = 'creditCard';
        dataDeterminePriority.variableForText = getTextForCreditCard(creditCardLocalStorageData);
        const { variableForText } = dataDeterminePriority;
        dataDeterminePriority.text = creditCardRetentionData?.[variableForText];
    } else if (debitCardDeliveryLocalStorageData && !noStretchingArray?.includes('dcard_delivery')) {
        dataDeterminePriority.currentCard = 'debitCardDelivery';
        dataDeterminePriority.variableForText = getTextForDcardDelivery(debitCardDeliveryLocalStorageData);
        const { variableForText } = dataDeterminePriority;
        dataDeterminePriority.text = debitCardDeliveryRetentionData?.[variableForText];
    } else if (debitCardLocalStorageData && !noStretchingArray?.includes('dcard')) {
        dataDeterminePriority.currentCard = 'debitCard';
        dataDeterminePriority.variableForText = getTextForDebitCard(debitCardLocalStorageData);
        const { variableForText } = dataDeterminePriority;
        dataDeterminePriority.text = debitCardRetentionData?.[variableForText];
    } else {
        dataDeterminePriority.currentCard = false;
    }

    return dataDeterminePriority;
}
